import { render, staticRenderFns } from "./DashboardLectorPatrocinadores.vue?vue&type=template&id=0a160869&"
import script from "./DashboardLectorPatrocinadores.vue?vue&type=script&lang=js&"
export * from "./DashboardLectorPatrocinadores.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports